import OnePlatformCommonActions from "@frameworks/web/redux/actions/common/commonActions";
import { LEDGER_SNAPSHOT } from "@frameworks/web/redux/interfaces/Reports/ILedgerSnapShot";
class LedgerSnapShotActions extends OnePlatformCommonActions {
    getLedgerSnapShot(snapShot, type) {
        this.dispatch({
            type: LEDGER_SNAPSHOT,
            payload: { snapShot },
            reducerName: type,
        });
    }
}
export default LedgerSnapShotActions;
